/*
 * ExplicitRemoveModal Messages
 *
 * This contains all the text for the ExplicitRemoveModal component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  intro: {
    id: 'app.components.ExplicitRemoveModal.label',
    defaultMessage: 'Type "{lcText}" and click the "{text}" button:',
  },
  feedback: {
    id: 'app.components.ExplicitRemoveModal.feedback',
    defaultMessage: 'Type "{lcText}"',
  },
  remove: {
    id: 'app.common.remove',
    defaultMessage: 'Remove',
  },
});
